<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->

<div class="container" *ngIf="!hideHeader && !minimalisticHeader" automationId="stepper">
	<div class="progress-container">
		<div class="progress" [ngStyle]="{ width: progressWidth }"></div>
		<div class="step-node" *ngFor="let step of steps; index as i">
			<div class="circle" [ngClass]="{ active: _currentStep >= i }" automationId="stepperNode">
				{{ i + 1 }}
			</div>
			<div class="step-title" automationId="stepperTitle">
				<span>{{ steps[i] }}</span>
			</div>
		</div>
	</div>
</div>
<div
	class="container minimalistic"
	*ngIf="!hideHeader && minimalisticHeader"
	automationId="minimalisticStepper"
>
	<div class="step-node">
		<div class="circle active" automationId="stepperNode">{{ _currentStep + 1 }}</div>
		<span class="title" automationId="stepperTitle">{{ steps[_currentStep] }}</span>
	</div>
</div>

<ng-content #stepperContent></ng-content>
